


















































































import moment from 'moment';
import { Component, Prop, Vue } from 'vue-property-decorator';
import { Terms } from '@/api';

/**
 * The current T&Cs version, for staff. Read-only, and there is no write
 * endpoint to call even if this screen wanted one.
 *
 * Django is the authority for the version *label* and a hash of the content
 * only; the text itself is a WordPress page, which is also where the label is
 * set. One writer is the point - it is what stops the version and the hash
 * disagreeing.
 *
 * Bidders never see any of this: the version is only useful for comparing
 * against the version a bidder accepted.
 */
@Component({
  components: {},
})
export default class extends Vue {
  @Prop({ required: false }) readonly routeTitle: string;

  terms: Terms | null = null;

  error: string = '';

  formatDateTime(date: string) {
    return moment(date).format('MMM D, YYYY h:mm a');
  }

  async mounted() {
    try {
      this.terms = await Terms.current();
      if (!this.terms) {
        this.error = 'No terms version has been recorded yet.';
      }
    } catch (err) {
      this.error = 'The current terms version could not be loaded.';
    }
  }
}
